// extracted by mini-css-extract-plugin
module.exports = {"container":"GroupFormLayout_container__2-mII","title":"GroupFormLayout_title__3qQJV","subtitle":"GroupFormLayout_subtitle__39Mlt","top":"GroupFormLayout_top__mE-6i"};